import React from 'react';
import { Box, Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    group: {
        display: 'inline-flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 6,
    },
    chip: {
        height: 26,
        fontSize: 12,
        fontWeight: 500,
        cursor: 'pointer',
        borderRadius: 16,
    },
    chipActiveOn: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        border: `1px solid ${theme.palette.primary.main}`,
        fontWeight: 600,
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            opacity: 0.92,
        },
    },
    chipActiveOff: {
        backgroundColor: '#fff',
        color: '#9CA3AF',
        border: '1px solid #E5E7EB',
        '&:hover': {
            backgroundColor: '#F9FAFB',
            borderColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
        },
    },
    chipInactiveOn: {
        backgroundColor: '#F4F4F6',
        color: '#4B5563',
        border: '1px solid #E0E0E6',
        fontWeight: 600,
        '&:hover': {
            backgroundColor: '#ECECF2',
        },
    },
    chipInactiveOff: {
        backgroundColor: '#fff',
        color: '#9CA3AF',
        border: '1px solid #E5E7EB',
        '&:hover': {
            backgroundColor: '#F9FAFB',
            borderColor: '#D1D5DB',
            color: '#4B5563',
        },
    },
}));

const RuleActiveToggle = ({ active, onChange, disabled }) => {
    const classes = useStyles();
    const isActive = Boolean(active);

    return (
        <Box className={classes.group} role="group" aria-label="Estado: Activa o Inactiva">
            <Chip
                size="small"
                label="Activa"
                disabled={disabled}
                clickable={!disabled}
                onClick={() => {
                    if (!isActive) onChange(true);
                }}
                classes={{
                    root: `${classes.chip} ${isActive ? classes.chipActiveOn : classes.chipActiveOff}`,
                }}
                aria-pressed={isActive}
            />
            <Chip
                size="small"
                label="Inactiva"
                disabled={disabled}
                clickable={!disabled}
                onClick={() => {
                    if (isActive) onChange(false);
                }}
                classes={{
                    root: `${classes.chip} ${!isActive ? classes.chipInactiveOn : classes.chipInactiveOff}`,
                }}
                aria-pressed={!isActive}
            />
        </Box>
    );
};

export default RuleActiveToggle;
